<template>
    <modal
        :saveAction="saveAction"
        :deleteAction="data._id ? data.can_delete ? deleteService : false : false"
        :title="$t(title)"
        :id="id"
        :actionButtons="!hideForm"
        size="lg"
        :closeButton="hideForm"
        @shown="shown"
    >
        <form class="mb-4" v-if="!hideForm">
            <div class="row">
                <div class="col-12 col-md-12">
                    <div class="form-group">
                        <label for="label">{{$t('Service name')}}*</label>
                        <b-form-input
                            id="label"
                            v-model.trim="data.label"
                            type="text"
                            :autofocus="true"
                            :state="validation('label')"
                            :placeholder="$t('Ex.: Consultation')"
                        ></b-form-input>
                    </div>
                </div>
                <div class="col-12 col-md-12">
                    <div class="form-group">
                        <label for="description">{{$t('Description')}}</label>
                        <b-form-textarea
                            v-model.trim="data.description"
                            id="description"
                            type="text"
                            :state="validation('description')"
                            :placeholder="$t('Describe service')"
                        ></b-form-textarea>
                    </div>
                </div>

                <div class="col-12 col-md-12">
                    <custom-switch
                        id="isServicePublic"
                        :title="$t('Public section')"
                        v-model="data.public"
                        :subtitle="$t('Public sections will be published.')"
                    ></custom-switch>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import CustomSwitch from "@/components/CustomSwitch.vue";
import Avatar from '@/components/Avatar.vue'
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    name: 'service-modal',
    props: ['id', 'data'],
    components: {
        Modal,
        Avatar,
        CustomSwitch,
    },
    data() {
        return {
            loading: false,
            hideForm: false,
            title: 'Service',
            calendarOptions: {
                static: false,
                wrap: true,
                altFormat: 'F j, Y',
                dateFormat: "F j, Y",
                ariaDateFormat: 'd.m.Y',
                maxDate: new Date(),
            },
            errors: {},
        }
    },
    computed: {
        couldBeDeleted() {
            if (!this.data._id) return false;
            if (this.data.totalTreatments > 0) return false;
            return true;
        },
    },
    mounted() {

        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
    },

    methods: {
        ...mapActions('service', ['create', 'patch', 'remove']),

        deleteService() {
            this.remove(this.data._id);
            this.$root.$emit('bv::hide::modal', this.id);
            this.$toasted.global.success({
                message: 'Service has been removed'
            });
        },
        saveAction() {
            let promise, successMessage;

            if (this.data._id) {
                promise = this.patch([this.data._id, this.data]);
                successMessage = 'Service has been saved';
            } else {
                this.data.totalTreatments = 0;
                promise = this.create(this.data);
                successMessage = 'Service has been created';
            }
            promise.then(data => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });

            promise.catch(err => {
                this.errors = err.errors;
            });

        },
        shown() {
            console.log('show');
            this.errors = {};
            // this.data = {};
        },

        validation(field) {

            if (this.errors && this.errors[field])
                return false
            else
                return null
        }
    },

}
</script>
